export const HVAC_INSIGHTS_ACTIONS = {
    FETCH_DATA: 'FETCH_HVAC_INSIGHTS_DATA',
    IMAGE_LOADED: 'HVAC_INSIGHTS_IMAGE_LOADED'
  };

export const onImageLoad = () => ({
    type: HVAC_INSIGHTS_ACTIONS.IMAGE_LOADED
});
